export { default } from './CardHeader';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/CardHeader/index.js
// module id = 817
// module chunks = 2